'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCallEnd = function MdCallEnd(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 15c-2.7 0-5.2 0.4-7.7 1.2v5.1c0 0.7-0.3 1.4-0.9 1.6-1.6 0.8-3.1 1.8-4.4 3-0.4 0.4-0.7 0.5-1.2 0.5s-0.9-0.2-1.2-0.5l-4.1-4.1c-0.3-0.3-0.5-0.7-0.5-1.2s0.2-0.8 0.5-1.1c5.1-4.9 11.9-7.9 19.5-7.9s14.5 3 19.5 7.9c0.3 0.3 0.5 0.7 0.5 1.1s-0.2 0.9-0.5 1.2l-4.1 4.1c-0.3 0.4-0.7 0.5-1.2 0.5s-0.8-0.2-1.2-0.5c-1.3-1.2-2.8-2.2-4.4-3-0.6-0.2-0.9-0.8-0.9-1.5v-5.1c-2.5-0.8-5-1.3-7.7-1.3z' })
        )
    );
};

exports.default = MdCallEnd;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/call-end.js
// module id = 2140
// module chunks = 0